import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c6-six-three-three-one',
  templateUrl: './c6-six-three-three-one.component.html',
  styleUrls: ['./c6-six-three-three-one.component.scss']
})
export class C6SixThreeThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
